enum SortingAlgo {
    BUBBLE = 'Bubble Sort',
    INSERTION = 'Insertion Sort',
    SELECTION = 'Selection Sort',
    QUICK = 'Quick Sort',
    MERGE = 'Merge Sort',
}

export default SortingAlgo;
